import { render, staticRenderFns } from "./ActionLogs.vue?vue&type=template&id=bab8518e&scoped=true&"
import script from "./ActionLogs.vue?vue&type=script&lang=js&"
export * from "./ActionLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab8518e",
  null
  
)

export default component.exports